import { Injectable } from '@angular/core';
import { SCData } from '@app/models/core/SCData';
import { environment } from '@env/environment';
import { UntilDestroy } from '@ngneat/until-destroy';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BaseService } from './helperclasses/baseservice';
import { HttpService } from './http/http.service';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class TranslationsService extends BaseService {
  constructor(private http: HttpService) {
    super();
  }

  getLanguageFiles() {
    const observables = [];
    for (const languageCode of environment.supportedLanguages) {
      observables.push(this.getLanguageFile(languageCode));
    }
    return combineLatest(observables).pipe(
      filter((resp) => {
        for (const tmp of resp) {
          if (tmp == undefined) {
            return false;
          }
        }
        return true;
      }),
      map((resp) => {
        return resp.map((resp, index) => {
          return {
            languageCode: environment.supportedLanguages[index],
            translations: resp.data,
          };
        });
      }),
    );
  }

  getLanguageFile(languageCode: string) {
    return <Observable<SCData<{ [index: string]: string }>>>(
      this.http.get(`/translations/${languageCode}/file`)
    );
  }
}
